/**
 * Состав пака «mono-glam» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 52 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 32 из 52 воронок: palette → ближайшая тема по цветам
    { themeId: 'bento-brutalist', weight: 0.62 },
    // 4 из 52 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.08 },
    // 4 из 52 воронок: palette → ближайшая тема по цветам
    { themeId: 'midnight-emerald', weight: 0.08 },
  ],
  fonts: [
    // 48 из 52 воронок: fontId
    { fontId: 'inter', weight: 0.92 },
    // 2 из 52 воронок: fontId
    { fontId: 'montserrat', weight: 0.04 },
  ],
  screenKinds: [
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.423
    { kind: 'N10', share: 0.5 },
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.103; сюда свёрнуты Q10, Q13, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.12 },
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.068
    { kind: 'N4', share: 0.08 },
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.060
    { kind: 'N3', share: 0.07 },
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.050; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.06 },
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.049; сюда свёрнуты Q11, Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.06 },
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.048
    { kind: 'I1', share: 0.06 },
    // средняя доля экранов по 52 воронкам (признаки.json kinds) 0.048
    { kind: 'N2', share: 0.06 },
  ],
  blocks: [
    // в 16 из 52 воронок (признаки.json blocks), подъём 0.45; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 44 из 69, optionIndicator 58 из 69
    {
      type: 'single_choice',
      weight: 0.31,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 7 из 52 воронок (признаки.json blocks), подъём 0.30; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 10 из 15
    {
      type: 'multiple_choice',
      weight: 0.13,
      settings: { optionIndicator: 'none' },
    },
    // в 35 из 52 воронок (признаки.json blocks), подъём 1.41
    { type: 'loader_processing', weight: 0.67, settings: {} },
  ],
  niches: [
    // 6 из 52 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.12 },
    // 5 из 52 воронок (признаки.json theme)
    { niche: 'meditation', weight: 0.1 },
    // 4 из 52 воронок (признаки.json theme)
    { niche: 'relationships', weight: 0.08 },
    // 3 из 52 воронок (признаки.json theme)
    { niche: 'ai_companion', weight: 0.06 },
  ],
};
